import axiosInstance from '../../api/axios';

const baseUrl = '/ai-chat';

const unwrapResponse = (response) => {
  const payload = response.data;
  return payload?.data ?? payload;
};

const parseSsePayload = (line) => {
  const data = line.replace(/^data:\s*/, '').trim();
  if (!data || data === '[DONE]') return null;
  return JSON.parse(data);
};

const AiChatService = {
  getTeachers: async () => {
    const response = await axiosInstance.get(`${baseUrl}/teachers`);
    return unwrapResponse(response);
  },

  getTeacher: async (teacherId) => {
    const response = await axiosInstance.get(`${baseUrl}/teachers/${teacherId}`);
    return unwrapResponse(response);
  },

  getTeacherSessions: async (teacherId) => {
    const response = await axiosInstance.get(`${baseUrl}/sessions/teacher/${teacherId}`);
    return unwrapResponse(response);
  },

  createSession: async ({ teacher_id, title }) => {
    const response = await axiosInstance.post(`${baseUrl}/sessions`, { teacher_id, title });
    return unwrapResponse(response);
  },

  getSession: async (sessionId) => {
    const response = await axiosInstance.get(`${baseUrl}/sessions/${sessionId}`);
    return unwrapResponse(response);
  },

  deleteSession: async (sessionId) => {
    const response = await axiosInstance.delete(`${baseUrl}/sessions/${sessionId}`);
    return unwrapResponse(response);
  },

  getSessionTokenCount: async (sessionId) => {
    const response = await axiosInstance.get(`${baseUrl}/sessions/${sessionId}/tokens`);
    return unwrapResponse(response);
  },

  streamChatMessage: async (sessionId, message, { onChunk, onDone } = {}) => {
    let lastLength = 0;
    let buffer = '';
    let donePayload = null;

    const handleRawChunk = (rawChunk) => {
      if (!rawChunk) return;

      buffer += rawChunk;
      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      lines.forEach((rawLine) => {
        const line = rawLine.trim();
        if (!line.startsWith('data:')) return;

        const payload = parseSsePayload(line);
        if (!payload) return;

        if (payload.error) {
          throw new Error(payload.message || 'Erreur pendant la generation de la reponse IA');
        }

        if (payload.text) {
          onChunk?.(payload.text);
        }

        if (payload.done) {
          donePayload = payload;
          onDone?.(payload);
        }
      });
    };

    const response = await axiosInstance.post(
      `${baseUrl}/sessions/${sessionId}/messages`,
      { message },
      {
        responseType: 'text',
        headers: { Accept: 'text/event-stream' },
        onDownloadProgress: (progressEvent) => {
          const xhr = progressEvent.event?.target;
          const responseText = xhr?.responseText;
          if (!responseText) return;

          const nextChunk = responseText.slice(lastLength);
          lastLength = responseText.length;
          handleRawChunk(nextChunk);
        },
      }
    );

    const remainder = typeof response.data === 'string' ? response.data.slice(lastLength) : '';
    handleRawChunk(remainder);

    if (buffer.trim().startsWith('data:')) {
      handleRawChunk('\n');
    }

    return donePayload;
  },
};

export default AiChatService;
